<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 mb-4">
            <template v-if="oldEvaluationWorks && oldEvaluationWorks.data && oldEvaluationWorks.data.length > 0">
              <div class="mb-4">
                <div class="section-header font-weight-bold old-evaluation-works-collapse" v-b-toggle.old-evaluation-works>
                  <h4>
                    <i class="fa fa-arrow-down"></i>
                    Олдин бахоланганлар
                    <span class="badge badge-warning d-inline-flex align-items-center justify-content-center m-1">{{ oldEvaluationWorks.data.length }}</span>
                  </h4>
                </div>
                <b-collapse id="old-evaluation-works" accordion="old-evaluation-works" role="tabpanel">
                  <div class="row">
                    <div class="col-12 col-md-6 col-xl-4" v-for="oldWork in oldEvaluationWorks.data" :key="'work_' + oldWork.id">
                      <div class="alert alert-secondary alert-dismissible fade show alert-wrap" role="alert">
                        <a class="alert-heading" :href="oldWork.url + `/new-real-estate/edit/${oldWork.id}`" target="_blank">#{{oldWork.id}}  {{oldWork.name}}</a>
                        <p class="font-weight-bold pl-3 mt-1">{{oldWork.total | currency('', 2, { thousandsSeparator: ' ' })}} сўм</p>
                        <p class="alert-item mb-0"> Бахоланган сана
                          <span v-if="oldWork.confirmedDate">{{oldWork.confirmedDate}} </span>
                          <span v-else>{{new Date(oldWork.createdDate) | dateFormat('DD/MM/YYYY hh:mm')}}</span>
                        </p>
                        <p class="alert-item mb-0">Бахолаш мақсади <span class="badge badge-pill badge-warning" v-if="oldWork.evlGoalTypeDto">{{oldWork.evlGoalTypeDto.typeName}} </span></p>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </template>
          </div>
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationRespectiveType")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="auto.evaluationRespectiveType"
                                            :class="{invalid : $v.auto.evaluationRespectiveType.$error}">
                                        <option :value="option.code" v-for="option in evaluationRespectiveTypes"
                                                :key="option.code">
                                            {{option.displayName}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.auto.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationRespectiveType")}}
                                    </div>
                                </div>
                                <div class="form-row" v-if="isTenders">
                                    <div class="form-group col-md-4">
                                        <label>{{$t("realEstate.field.tenderContractDate")}} <span class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy"
                                                    v-model="tenderContractDate"
                                                    :date="tenderContractDate"
                                                    :clear-button="true"
                                                    :class="{invalid:$v.tenderContractDate.$error}"></datepicker>
                                        <div class="red" v-if="$v.tenderContractDate.$error">
                                            {{$t("realEstate.field.tenderContractDate")}}
                                        </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>
                                            {{$t("realEstate.field.tenderContractNumber")}} <span class="red">*</span>
                                        </label>
                                        <input type="text" class="form-control"
                                               :class="{invalid: $v.auto.tenderContractNumber.$error}"
                                               v-model="auto.tenderContractNumber">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                                    <v-select v-model="auto.ownerClient" label="text"
                                              :options="owners"
                                              :filterable="false"
                                              @search="onOwnerSearch"
                                              @search:focus="onOwnerFocus"
                                              :class="{invalid : $v.auto.ownerClient.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="auto && auto.ownerClient && auto.ownerClient.text">
                                            <div v-html="auto.ownerClient.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.auto.ownerClient.$error">
                                        {{$t("realEstate.validation.ownerClient")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="hasPermission('NEW_AUTO_WITH_LETTER_ATTORNEY')">
                                    <div class="form-check pl-0">
                                        <label class="form-check-label" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="auto.hasCustomerClient">
                                            <span class="form-check-sign"></span>
                                            {{$t("realEstate.field.withLetterOfAttorney")}}
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group" v-if="auto.hasCustomerClient">
                                    <label>Буйюртмачи <span
                                            class="red">*</span></label>
                                    <v-select v-model="auto.customerClient" label="text"
                                              :options="customers"
                                              :filterable="false"
                                              @search="onCustomerSearch"
                                              @search:focus="onCustomerFocus"
                                              :class="{invalid : $v.auto.customerClient.$error}">
                                        <template slot="option" slot-scope="option" v-if="option && option.text">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="auto && auto.customerClient && auto.customerClient.text">
                                            <div v-html="auto.customerClient.text"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.auto.customerClient.$error">
                                        Буйюртмачи
                                    </div>
                                </div>

                                <div class="form-group" v-if="auto.hasCustomerClient">
                                    <label>Ишончнома номери: <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="auto.powerOfAttorneyNumber"
                                           :class="{invalid : $v.auto.powerOfAttorneyNumber.$error}"/>
                                    <div class="red" v-if="$v.auto.powerOfAttorneyNumber.$error">Ишончнома номери
                                    </div>
                                </div>

                                <div class="form-group" v-if="auto.hasCustomerClient">
                                    <label>Ишончнома санаси: <span class="red">*</span></label>
                                    <datepicker class="form-control" format="dd/MM/yyyy"
                                                v-model="powerOfAttorneyDate"
                                                :clear-button="true"
                                                :class="{invalid : $v.powerOfAttorneyDate.$error}"></datepicker>
                                    <div class="red" v-if="$v.powerOfAttorneyDate.$error">Ишончнома санаси:
                                    </div>
                                </div>

                                <template v-if="isOrgTypeMib">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibDebtorName")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="auto.debtor"
                                               :class="{invalid : $v.auto.debtor.$error}"/>
                                        <div class="red" v-if="$v.auto.debtor.$error">
                                            {{$t("realEstate.validation.mibDebtorName")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterNumber")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="auto.letterNumber"
                                               :class="{invalid : $v.auto.letterNumber.$error}"/>
                                        <div class="red" v-if="$v.auto.letterNumber.$error">
                                            {{$t("realEstate.validation.mibLetterNumber")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterDate")}} <span
                                                class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="contractDate"
                                                    :clear-button="true"
                                                    :class="{invalid : $v.contractDate.$error}"></datepicker>
                                        <div class="red" v-if="$v.contractDate.$error">
                                            {{$t("realEstate.validation.mibLetterDate")}}
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationPurpose")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="auto.evlGoalType"
                                            :class="{invalid : $v.auto.evlGoalType.$error}"
                                            :disabled="!!auto.id && auto.entiteCreateType !== 'API_EXARID'">
                                        <option :value="option.key" v-for="option in goalTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.auto.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationPurpose")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.propertyType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="auto.evlPropertyType"
                                            :class="{invalid : $v.auto.evlPropertyType.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.auto.evlPropertyType.$error">
                                        {{$t("realEstate.validation.propertyType")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluator")}} <span class="red">*</span></label>
                                    <v-select v-model="auto.employee" label="text"
                                              :options="employees"
                                              :filterable="false"
                                              @search="onEmployeeSearch"
                                              @search:focus="onEmployeeFocus"
                                              :class="{invalid : $v.auto.employee.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="auto && auto.employee && auto.employee.text">
                                            <div v-html="auto.employee.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.auto.employee.$error">
                                        {{$t("realEstate.validation.evaluator")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.contractAmount")}}</label>
                                    <numeric-input class="form-control" v-model="auto.evlContractAmount"
                                                   :controls="false" :precision="2"
                                                   :disabled="isOrgType || isPaid"></numeric-input>

                                    <div v-if="isOwnerTypeLegal && !isOrgTypeMib">
                                        <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                                        <numeric-input class="form-control" v-model="auto.prepayment"
                                                       :controls="false" :precision="2"></numeric-input>
                                    </div>

                                    <span style="color: green">ҚҚС билан: {{auto.evlAmountToPay | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                    <div class="form-group" style="color: blue">
                                        <span>Туланган сумма: {{auto.evlAmountPaid | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluatorIdea")}}</label>
                                    <textarea type="text" class="form-control"
                                              v-model="auto.evaluatorIdea"></textarea>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluatorRestrictiveTerms")}}</label>
                                    <textarea type="text" class="form-control"
                                              v-model="auto.evaluatorRestrictiveTerms"></textarea>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>{{$t("auto.autoDocs")}}</h4>
                                </div>
                            </div>
                            <template v-if="(auto.ownerClient || auto.entiteCreateType === 'API_EXARID') && !isPageLoadInit">

                                <AssetDropZone code="documentsDropZone" :label="documentOrPassportLbl"
                                               folder="Letter" :folderName="'Auto'"
                                               :data="auto.letterFiles"
                                               @change="(files) => {auto.letterFiles = files}"
                                               :removeFile="canRemoveFile"
                                               :editable="canSave"
                                               :has-error="$v.auto.letterFiles.$error"/>

                                <template>
                                    <AssetDropZone code="actOfSaleDropZone" label="asset.actOfSale"
                                                   folder="ActOfSale" :folderName="'Auto'"
                                                   :data="auto.actOfSaleFiles"
                                                   @change="(files) => {auto.actOfSaleFiles = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                                   :has-error="$v.auto.actOfSaleFiles.$error"/>
                                    <AssetDropZone code="decisionDropZone" label="asset.decision"
                                                   folder="Decision" :folderName="'Auto'"
                                                   :data="auto.decisionFiles"
                                                   @change="(files) => {auto.decisionFiles = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                                   :has-error="$v.auto.decisionFiles.$error"/>
                                    <AssetDropZone code="playlistDropZone" label="asset.playlist"
                                                   folder="ExecutivePlaylist" :folderName="'Auto'"
                                                   :data="auto.executivePlaylistFiles"
                                                   @change="(files) => {auto.executivePlaylistFiles = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                    />
                                </template>
                            </template>
                        </div>

                        <div class="row" v-if="auto.id && auto.id > 0 && auto.entiteCreateType !== 'INSIDE'">
                              <template>
                                  <PreviewDropZone code="checkPaymentDropZone" :label="checkPaymentLbl"
                                                   :data="auto.checkPaymentFiles"
                                                   @change="(files) => {asset.checkPaymentFiles = files}"
                                  />
                              </template>
                              <div class="form-check checkbox-inline">
                                  <label class="form-check-label pl-3 font-weight-bold">
                                      <input class="form-check-input" type="checkbox"
                                             v-model="auto.displayReport"
                                             @change="showReport()"
                                             v-bind:disabled="!hasPermission('NEW_AUTO_DISPLAY_REPORT')"
                                      >
                                      <span class="form-check-sign"></span>
                                      {{$t("report.field.showReport")}}
                                  </label>
                              </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 mt-2">
                                <div class="form-group">
                                    <fitment-status-view :fitment="auto" v-if="auto.id"/>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 mt-2">
                                <div class="form-group">
                                    <fitment-history-view v-if="auto.id"/>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="showReportButton">
                            <div class="col-12 btns-box">
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_REPORT_WORD_QR_CODE')"
                                        @click="reportDocQrCode(auto)">
                                    <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWordQrCode")}}
                                </button>
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_REPORT_WORD')"
                                        @click="reportDoc(auto)">
                                    <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_REPORT_PDF_QR_CODE')"
                                        @click="reportPdfQrCode(auto)">
                                    <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_REPORT_PDF')"
                                        @click="reportPdf(auto)">
                                    <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_CONTRACT_PDF_QR_CODE')"
                                        @click="contractQrCodePdf(auto)">
                                    <i v-if="loading.isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdfQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_CONTRACT_PDF')"
                                        @click="contractPdf(auto)">
                                    <i v-if="loading.isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdf")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_CONTRACT_WORD_QR_CODE')"
                                        @click="contractDocQrCode(auto)">
                                    <i v-if="loading.isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWordQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_AUTO_CONTRACT_WORD')"
                                        @click="contractDoc(auto)">
                                    <i v-if="loading.isCDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWord")}}
                                </button>
                                <button class="btn btn-primary pull-right mr-2 btn-sm"
                                        v-if="hasPermission('NEW_AUTO_REPORT_PDF_NOT_SIGNED_AND_QRCODE')"
                                        @click="notSignedAndQRCodeReportPdf(auto)">
                                    <i v-if="loading.isPdfNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button
                                        class="btn btn-primary pull-right mr-2 btn-sm"
                                        v-if="hasPermission('NEW_AUTO_REPORT_WORD_NOT_SIGNED_AND_QRCODE')"
                                        @click="notSignedAndQRCodeReportDoc(auto)">
                                    <i v-if="loading.isDocNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                            </div>
                        </div>

                        <div class="row" v-if="auto.id && auto.id > 0">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">
                                        {{$t("auto.autoToEvaluate")}}
                                    </h4>
                                    <button class="all-btn add-btn pull-right ml-2"
                                            v-if="canSave && !isLoses" @click="addAuto">
                                        {{$t("auto.addAuto")}}
                                    </button>
                                </div>
                                <div class="table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th width="5%">№</th>
                                            <th width="30%">Автотранспорт номи</th>
                                            <th width="15%">Киритилган сана</th>
                                            <th width="15%">Томонидан яратилган</th>
                                            <th width="15%">БАХОЛАНГАН ҚИЙМАТИ</th>
                                            <th width="100%">ЖАРАЁН</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in auto.evaluationAutoDtoList" :key="item.id">
                                            <td>{{index+1}}</td>
                                            <td>{{item.name}}</td>
                                            <td>{{new Date(auto.createDate) | dateFormat('DD/MM/YYYY')}}</td>
                                            <td>{{auto.createUserName}}</td>
                                            <td>
                                                {{item.evlPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                            </td>
                                            <td class="td-actions text-center direction-row">
                                                <div>
                                                    <button @click="addEditPushItem(item.id, auto.id)"
                                                            v-tooltip="'Ўзгартириш'"
                                                            class="all-btn dark-btn table-action">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                </div>
                                                <div v-if="!isLoses">
                                                    <button v-if="item.approachOne" type="button" v-tooltip="'Харажат ёндашув'"
                                                            class="all-btn add-btn table-action"
                                                            @click="showAutoCalculation(item.id)">
                                                        <i class="fa fa-calculator"></i>
                                                    </button>
                                                </div>
                                                <div v-if="!canSelect">
                                                    <button v-if="item.approachThree" type="button" v-tooltip="'Қиёсий ёндашув'"
                                                            class="all-btn edit-btn table-action"
                                                            @click="showComparative(item.id)">
                                                        <i class="fa fa-balance-scale"></i>
                                                    </button>
                                                </div>

                                                <div v-if="canSelect">
                                                    <button v-if="item.approachThree" type="button" v-tooltip="'Қиёсий ёндашув'"
                                                            class="all-btn edit-btn table-action"
                                                            @click="showComparativeMutable(item.id)">
                                                        <i class="fa fa-balance-scale"></i>
                                                    </button>
                                                </div>
                                                <div v-if="!isLoses">
                                                    <button type="button" v-tooltip="'Мувофиқлаштириш'"
                                                            class="all-btn dark-btn table-action"
                                                            @click="showCorrectionType(item)">
                                                        <i class="fa fa-window-restore"></i>
                                                    </button>
                                                </div>
                                                <!--<div class="col-2" v-if="isLoses && item.losesDilapidationValue">-->
                                                    <!--<button type="button" v-tooltip="'Дефект аст'"-->
                                                            <!--class="all-btn dark-btn table-action"-->
                                                            <!--@click="showDefectAct(item.id)">-->
                                                        <!--<i class="fa fa-calculator"></i>-->
                                                    <!--</button>-->
                                                <!--</div>-->
                                                <div v-if="isLoses && item.losesDilapidationValue">
                                                    <router-link tag="button"
                                                                 :to="'/auto/defect/act/' + item.id + '/' + auto.id"
                                                                 v-tooltip="'Дефект аст'"
                                                                 class="all-btn edit-btn table-action">
                                                        <i class="fa fa-edit"></i>
                                                    </router-link>
                                                </div>
                                                <div>
                                                    <button type="button" v-tooltip="'Ўчириш'" v-if="auto.evlObjectType !== 'Auto' && canSave"
                                                            class="all-btn delete-btn table-action"
                                                            @click="showDeleteAutoItemDialog(item, index)">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing">
                                    {{$t("action.save")}}
                                </button>
                                <button class="all-btn" @click="changeStatus('Rated')" :disabled="processing" v-if="canEvaluate">
                                    {{$t("realEstate.action.evaluate")}}
                                </button>
                                <button class="all-btn add-btn" @click="changeStatus('Confirmed')" :disabled="processing"
                                        v-if="canConfirm && (auto.appraiserReportEsp || !auto.hasEsp)">
                                    {{$t("realEstate.action.confirm")}}
                                </button>
                                <button class="all-btn" @click="openSignPageAppraiser(auto)" :disabled="processing"
                                        v-if="canConfirm && auto.hasEsp && !auto.appraiserReportEsp">
                                    Баҳоловчи тасдиқлаш (ЭЦП)
                                </button>
                                <button class="all-btn add-btn" @click="openSignPageDirector(auto)"
                                        :disabled="processing"
                                        v-if="hasPermission('NEW_AUTO_CONFIRM') && auto.appraisalStatusEnum === 'Confirmed' && auto.hasEsp && auto.appraiserReportEsp && !auto.directorReportEsp">
                                    Директор тасдиқлаш (ЭЦП)
                                </button>
                                <button class="all-btn edit-btn" @click="changeStatus('Unreviewed')"
                                        :disabled="processing" v-if="canReEvaluate">
                                    {{$t("realEstate.action.reevaluate")}}
                                </button>
                                <button class="all-btn ml-3" v-if="canSendAgent"
                                        :disabled="processing"
                                        @click="sendingExpert2ToAgent">
                                    {{$t('main.send')}}
                                </button>
<!--                              <button class="all-btn add-btn" v-if="canSendAgent"-->
<!--                                      @click="sendEvaluationObjectToIdentification(auto)"-->
<!--                                      :disabled="processing"-->
<!--                              >-->
<!--                                Идентификацияга бериш-->
<!--                              </button>-->

                              <button class="all-btn delete-btn" @click="deleteAuto(auto)"
                                        v-if="hasPermission('NEW_AUTO_DELETE')">
                                    {{$t("realEstate.delete.title")}}
                                </button>

                                <button class="all-btn add-btn" @click="sendReportToMIBAsset(auto)"
                                        v-if="hasPermission('NEW_AUTO_SEND_TO_MIB') && isMib && auto.appraisalStatusEnum === 'Confirmed'">
                                    {{$t("realEstate.action.sendReportToMIB")}}
                                </button>
                                <button class="all-btn delete-btn" v-if="canReject" @click="rejectOrder">
                                    <i class="fa fa-reply-all"></i>
                                    <span>Рад қилиш</span>
                                </button>
                                <!--<router-link-->
                                        <!--tag="button"-->
                                        <!--v-tooltip="'ЭЦПни тасдиқлаш'"-->
                                        <!--:to="'/auto/esp/' + auto.id"-->
                                        <!--class="all-btn pull-right ml-3"-->
                                        <!--v-if="hasPermission('NEW_AUTO_CONFIRM') && auto.appraisalStatusEnum === 'Confirmed' && auto.hasEsp"-->
                                <!--&gt;-->
                                    <!--{{$t("realEstate.action.espSign")}}-->
                                <!--</router-link>-->
                            </div>
                        </div>
                        <div class="row mt-2" v-if="auto.appraisalStatusEnum === 'Confirmed'">
                            <div class="col">
                                <div class="alert alert-warning d-flex">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong>
                                        Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш
                                        тугмасини босинг!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AutoEvaluationCalculation/>
        <AutoCorrectionType/>
        <ComparativeAuto/>
        <ComparativeMutableAuto/>
        <DefectAct/>
        <RejectComment/>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {numericTypes} from '@/shared/constants/mask'
    import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import {required, requiredUnless, minLength} from 'vuelidate/lib/validators';
    import {formatDate, parseDate} from '@/shared/utils';
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import FitmentStatusView from '@/views/fitment/FitmentStatusView.vue'
    import FitmentHistoryView from '@/views/fitment/FitmentHistoryView.vue'
    import AutoEvaluationCalculation from '@/views/auto/AutoEvaluationCalculation';
    import AutoCorrectionType from '@/views/auto/AutoCorrectionType';
    import ComparativeAuto from '@/views/auto/ComparativeAuto';
    import ComparativeMutableAuto from '@/views/auto/ComparativeMutableAuto';
    import DefectAct from '@/views/auto/DefectAct';
    import RejectComment from '@/components/RejectComment';
    import {BCollapse} from "bootstrap-vue/es/components/collapse/collapse";
    import {mapState} from "vuex";

    export default {
        name: "auto-add-edit",
        components: {
            BCollapse,
            AssetDropZone,
            Datepicker,
            PreviewDropZone,
            FitmentStatusView,
            FitmentHistoryView,
            AutoEvaluationCalculation,
            AutoCorrectionType,
            ComparativeAuto,
            ComparativeMutableAuto,
            DefectAct,
            RejectComment,
        },
        data() {
            return {
                processing: false,
                loading: {
                    isDocQrLoading: false,
                    isDocLoading: false,
                    isPdfLoading: false,
                    isPdfQrLoading: false,
                    isCDocLoading: false,
                    isCPdfLoading: false,
                    isCDocQrLoading: false,
                    isCPdfQrLoading: false,
                    isDocNotSignedAndQRCodeLoading: false,
                    isPdfNotSignedAndQRCodeLoading: false
                },
                isPageLoadInit: false,
                show: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                customerFilter: initFilterModel(),
                employeeFilter: initFilterModel(),
                auto: {
                    id: null,
                    ownerClient: {},
                    evlObjectType: 'Auto',
                    evlGoalType: null,
                    evlContractAmount: 0,
                    prepayment: 0,
                    employee: {},
                    evlValueType: 'Market',
                    evlPropertyType: '',

                    debtor: '',
                    letterNumber: null,
                    contractDate: null,
                    displayReport: false,
                    hasCustomerClient: false,
                    customerClient: null,
                    powerOfAttorneyDate: null,
                    powerOfAttorneyNumber: null,
                    evaluationAutoDtoList: [],

                    letterFiles: [],
                    actOfSaleFiles: [],
                    decisionFiles: [],
                    executivePlaylistFiles: [],
                    checkPaymentFiles: [],// to'lov haqidagi hujjatlar
                    appraisalStatusEnum: 'Unreviewed',
                    evaluationRespectiveType: "OTHER",
                    tenderContractDate: null,
                    tenderContractNumber: null,
                    evaluatorIdea: '',
                    evaluatorRestrictiveTerms: ''
                },
                oldEvaluationWorks: null,
                contractDate: null,
                tenderContractDate: null,
                powerOfAttorneyDate: null,
                owners: [],
                customers: [],
                employees: [],
                goalTypes: EVL_GOAL_TYPES,
                propertyTypes: EVL_PROPERTY_TYPES,
                evaluationRespectiveTypes: [],
                status: null,
                isDirector: false,
                isAppraiser: false
            }
        },
        validations() {
            return {
                auto: {
                    ownerClient: {
                        required: required
                    },
                    customerClient: {
                        required: requiredUnless(() => {
                            return !(this.auto.hasCustomerClient);
                        })
                    },
                    powerOfAttorneyNumber: {
                        required: requiredUnless(() => {
                            return !(this.auto.hasCustomerClient);
                        })
                    },
                    evlGoalType: {
                        required: required
                    },
                    evlPropertyType: {
                        required: required
                    },
                    employee: {
                        id: {
                            required: required
                        }
                    },
                    letterFiles: {
                        required: requiredUnless(() => {
                            return this.isMib || this.auto.entiteCreateType === 'EXPERT2';
                        }),
                        minLength: minLength(1)
                    },
                    actOfSaleFiles: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    decisionFiles: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    // MIB
                    debtor: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    letterNumber: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    evaluationRespectiveType: {
                        required: required
                    },
                    tenderContractNumber: {
                        required: requiredUnless(() => {
                            return !this.isTenders;
                        })
                    }
                },
                contractDate: {
                    required: requiredUnless(() => {
                        return !this.isOrgTypeMib;
                    })
                },
                tenderContractDate: {
                    required: requiredUnless(() => {
                        return !this.isTenders;
                    })
                },
                powerOfAttorneyDate: {
                    required: requiredUnless(() => {
                        return !(this.auto.hasCustomerClient);
                    })
                }
            };
        },
        computed: {
            ...mapState(['profile']),
            isOwnerTypePhysical() {
                return !!(this.auto.ownerClient && this.auto.ownerClient.type && this.auto.ownerClient.type === 'Physical');
            },
            isOwnerTypeLegal() {
                return !!(this.auto.ownerClient && this.auto.ownerClient.type && this.auto.ownerClient.type === 'Legal');
            },
            isMib() {
                return !!(this.auto.ownerClient && this.auto.ownerClient.organizationType && this.auto.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');

            },
            isOrgTypeMib() {
                return !!(this.auto.ownerClient &&
                    this.auto.ownerClient.organizationType &&
                    (this.auto.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.auto.ownerClient.organizationType === 'CUSTOMS_ADMINISTRATION'));
            },

            isOrgType() {
                return !!(this.auto.ownerClient &&
                    this.auto.ownerClient.organizationType &&
                    (this.auto.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION'));
            },
            documentOrPassportLbl() {
                if (this.auto) {
                    if (this.auto.ownerClient && this.auto.ownerClient.type && this.auto.ownerClient.type === 'Legal')
                        return "asset.document";
                    else
                        return "asset.passport";
                } else {
                    return "asset.passport";
                }
            },
            canConfirm() {
                return this.auto.appraisalStatusEnum === 'Rated' && this.hasPermission('NEW_AUTO_CONFIRM');
            },
            canReEvaluate() {
                return (this.auto.appraisalStatusEnum === 'Rated' || this.auto.appraisalStatusEnum === 'Confirmed') && this.hasPermission('NEW_AUTO_REEVALUATE');
            },
            canSave() {
                return ((this.auto.entiteCreateType === 'API_EXARID' || this.auto.entiteCreateType === 'INSIDE') && !this.auto.appraisalStatusEnum || this.auto.appraisalStatusEnum === 'Unreviewed' || this.auto.appraisalStatusEnum === 'NotFullyEvaluated' || this.auto.appraisalStatusEnum === 'SentToComplement');
            },
            canEvaluate() {
                return (this.auto.appraisalStatusEnum === 'Unreviewed');
            },
            showReportButton() {
                return (this.auto.appraisalStatusEnum === 'Rated' || this.auto.appraisalStatusEnum === 'Confirmed') && this.auto.id && this.auto.id > 0;
            },
            sendToMIBAssetReport() {
                return (this.auto.appraisalStatusEnum === 'Rated' || this.auto.appraisalStatusEnum === 'Confirmed') && this.auto.id && this.auto.id > 0;
            },
            checkPaymentLbl() {
                return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
            },
            isPaid() {
                return this.auto.evlAmountPaid > 0;
            },
            isLoses() {
                return this.auto.evlGoalType === "Losses";
            },
            canReject() {
                return (this.hasPermission('NEW_AUTO_EDIT') || this.isLoses
                    && this.hasPermission('NEW_AUTO_LOSES_EDIT'))
                    && (this.auto.appraisalStatusEnum === 'Unreviewed' || (this.auto.appraisalStatusEnum === 'NotFullyEvaluated' && this.isUserDirector))
                    && !this.auto.hasAppraiserReportEsp;
            },
            canSelect() {
                return this.hasPermission('NEW_AUTO_COMPARATIVE_ANALOGS_SELECT') || !this.isLoses && this.auto.appraisalStatusEnum === 'Unreviewed' && this.auto.appraisalStatusEnum === 'NotFullyEvaluated';
            },
            canRemoveFile() {
                return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status!=='Rejected' && this.hasPermission('NEW_AUTO_IMAGE_DELETE')
            },
            canSendAgent() {
                return (this.auto.appraisalStatusEnum === 'SentToComplement' && this.auto.entiteCreateType === 'EXPERT2' && this.hasPermission('NEW_AUTO_EDIT'))
            },
            isTenders() {
                return this.auto.evaluationRespectiveType === 'TENDERS';
            },
            isUserDirector() {
              return this.profile && this.profile.username === 'shohrux';
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                const promises = [];

                if (id && id > 0) {
                    vm.isPageLoadInit = true;
                    promises.push(this.$http.get('auto/' + id));

                    Promise.all(promises).then(function (values) {
                        if (values.length >= 0) {
                            const editData = values[0].data;
                            if (!editData.evlGoalType) {
                                editData.evlGoalType = '';
                            }
                            vm.contractDate = parseDate(editData.contractDate);
                            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
                            vm.tenderContractDate = parseDate(editData.tenderContractDate);
                            vm.auto = editData;
                            vm.auto.employee = {};
                            if (editData.employeeId && editData.employeeName) {
                                vm.auto.employee.id = editData.employeeId;
                                vm.auto.employee.text = editData.employeeName;
                            }

                            vm.status = editData.appraisalStatusEnum;
                            vm.isPageLoadInit = false;
                            vm.searchOldEvalautionWork()
                        }
                    });
                }
            },
            searchOldEvalautionWork() {
              const autoevl = {
                search: this.auto.evaluationAutoDtoList[0].bodyNum,
                evlGoalType: this.auto.evlGoalType
              };
              this.$http.post('auto/old-evaluation-works', autoevl)
                  .then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                      this.oldEvaluationWorks = res.data;
                    }
                  }, err => {
                    console.log(err);
                  });
            },
            cancel() {
                this.$router.push('/auto/list');
            },
            save() {
                this.saveAndGo();
            },
            saveAndGo() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                if (this.auto.prepayment && !(this.auto.prepayment >= 0 && this.auto.prepayment <= 100)) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
                        type: 'warning'
                    });
                    return;
                }

                this.processing = true;

                if (this.contractDate) {
                    this.auto.contractDate = formatDate(this.contractDate);
                }

                if (this.powerOfAttorneyDate) {
                    this.auto.powerOfAttorneyDate = formatDate(this.powerOfAttorneyDate);
                }

                if (this.tenderContractDate) {
                    this.auto.tenderContractDate = formatDate(this.tenderContractDate);
                }

                if (this.auto.employee) {
                    this.auto.employeeId = this.auto.employee.id;
                }

                if (this.isMib) {
                    this.auto.evlContractAmount = 0;
                }

                this.$http.post('auto/save', this.auto)
                    .then(res => {
                        console.log("res=", res)
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.auto.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/auto/edit/' + res.data.data.id);
                            this.editAuto(res.data.data.id);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.auto.statusError'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            editAuto(id) {
                const vm = this;
                const promises = [];
                if (id && id > 0) {
                    promises.push(this.$http.get('auto/' + id));
                    Promise.all(promises).then(function (values) {
                        if (values.length >= 0) {
                            const editData = values[0].data;
                            if (!editData.evlGoalType) {
                                editData.evlGoalType = '';
                            }
                            vm.contractDate = parseDate(editData.contractDate);
                            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
                            vm.auto = editData;
                            vm.auto.employee = {};
                            if (editData.employeeId && editData.employeeName) {
                                vm.auto.employee.id = editData.employeeId;
                                vm.auto.employee.text = editData.employeeName;
                            }
                        }
                    });
                }
            },

            addEditPushItem(itemId, autoId) {
                this.$router.push({
                    path: '/auto/item/edit/'+itemId+'/'+autoId,
                    query: {entiteCreateType: this.auto.entiteCreateType}
                });
            },

            addAuto() {
                this.$router.push({
                    path: '/auto/item/new/'+this.auto.id,
                    query: {entiteCreateType: this.auto.entiteCreateType}
                });
            },
            onOwnerSearch(searchTxt, loading) {
                loading(true);
                this.owners = [];
                this.ownerFilter.search = searchTxt;
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onOwnerFocus() {
                this.owners = [];
                this.ownerFilter.search = '';
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerSearch(searchTxt, loading) {
                loading(true);
                this.customers = [];
                this.customerFilter.search = searchTxt;
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerFocus() {
                this.customers = [];
                this.customerFilter.search = '';
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeSearch(searchTxt, loading) {
                loading(true);
                this.employees = [];
                this.employeeFilter.search = searchTxt;
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeFocus() {
                this.employees = [];
                this.employeeFilter.search = '';
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            showDeleteAutoItemDialog(item, index) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('asset.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('auto/item/delete/' + item.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.building.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.auto.evaluationAutoDtoList.splice(index, 1);
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.building.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            changeStatus(status) {
                this.processing = true;
                this.isPageLoadInit = true;

                this.$http.get('contractRegion/check-contract/' + this.auto.id + "/Auto").then(response => {
                    if (response.data.status !== 'SUCCESS' || response.data.status === 'SUCCESS' && response.data.code === 'ALLOWED') {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: response.data.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#dd3333',
                            confirmButtonText: 'Давом этиш',
                            cancelButtonText: 'Бекор қилиш'
                        }).then((result) => {
                            if (result.value) {
                                this.sendChangesToServer(status);
                            }
                            this.processing = false;
                        });
                    } else {
                        this.sendChangesToServer(status);
                    }
                });
            },
            sendChangesToServer(status) {
                this.$http.post('change/status', {
                    id: this.auto.id,
                    appraisalStatusEnum: status,
                }).then(res => {
                    if (res && res.data) {
                        if (res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('auto.statusSuccess'),
                                type: 'success'
                            });
                            this.auto.appraisalStatusEnum = status;
                            this.status = status;

                            console.log("this.status = ", status);
                            console.log("this.auto = ", this.auto);

                            if (status === 'Confirmed') {
                                if (this.auto.hasEsp) {
                                    this.openSignPageDirector(this.auto);
                                }
                            } else if (status === 'Rated') {
                                if (this.auto.hasEsp) {
                                    this.openSignPageAppraiser(this.auto);
                                }
                            } else if (status === 'Unreviewed') {
                                window.location.reload();
                            }

                        } else if (res.data.status === 'FAIL') {
                            if (res.data.code === 'NOT_COORDINATED') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Авто мулкни мувофиқлаштиринг!'),
                                    type: 'warning'
                                });
                                this.$router.push('/auto/real-estate/coordination/' + res.data.id);
                            } else if (res.data.code === 'COST_NOT_FOUND') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Харажат ёндашув танланган лекин ундан фойдаланилмаган!'),
                                    type: 'warning'
                                });
                                this.$router.push('/auto/real-estate/edit/' + res.data.id);
                            } else if (res.data.code === 'COMPARATIVE_NOT_FOUND') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Қийосий ёндашув танланган лекин ундан фойдаланилмаган!'),
                                    type: 'warning'
                                });
                                this.$router.push('/auto/real-estate/edit/' + res.data.id);
                            } else if (res.data.code === 'INCOME_NOT_FOUND') {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('Даромад ёндашув танланган лекин ундан фойдаланилмаган!'),
                                    type: 'warning'
                                });
                                this.$router.push('/auto/real-estate/edit/' + res.data.id);
                            }
                        } else if (res.data.status === 'ERROR') {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('auto.statusWarning'),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                    this.isPageLoadInit = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('auto.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                    this.isPageLoadInit = false;
                });
            },
            reportPdf: function (auto) {
                this.loading.isPdfLoading = true;
                this.downloadFile('/v2/autoReport/pdf/WITH_SIGNATURE/' + auto.hashUuid,
                    'Хисобот ' + auto.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isPdfLoading');
            },
            notSignedAndQRCodeReportPdf: function (auto) {
                this.loading.isPdfNotSignedAndQRCodeLoading = true;
                this.downloadFile('/v2/autoReportNotSignedAndQRCode/pdf/WITH_SIGNATURE/' + auto.hashUuid,
                    'Хисобот ' + auto.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isPdfNotSignedAndQRCodeLoading');
            },
            reportPdfQrCode: function (auto) {
                this.loading.isPdfQrLoading = true;
                this.downloadFile(`/v2/autoReport/pdf/WITH_QR_CODE/${auto.hashUuid}`,
                    'Хисобот ' + auto.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isPdfQrLoading');

            },
            reportDoc: function (auto) {
                this.loading.isDocLoading = true;
                this.downloadFile('/v2/autoReport/doc/WITH_SIGNATURE/' + auto.hashUuid,
                    'Хисобот ' + auto.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isDocLoading');
            },
            notSignedAndQRCodeReportDoc: function (auto) {
                this.loading.isDocNotSignedAndQRCodeLoading = true;
                this.downloadFile('/v2/autoReportNotSignedAndQRCode/doc/WITH_SIGNATURE/' + auto.hashUuid,
                    'Хисобот ' + auto.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isDocNotSignedAndQRCodeLoading');
            },
            reportDocQrCode: function (auto) {
                this.loading.isDocQrLoading = true;
                this.downloadFile('/v2/autoReport/doc/WITH_QR_CODE/' + auto.hashUuid,
                    'Хисобот ' + auto.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isDocQrLoading');
            },
            downloadFile: function (url, name, type, loading) {
                console.log(url);
                this.$http.get(url, {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: type});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = name;
                        link.click();
                        this.loading[loading] = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading[loading] = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.downloadFile(url, name, type, loading))
                        }
                    })
            },
            contractDocQrCode: function (auto) {
                this.loading.isCDocQrLoading = true;
                this.downloadFile('/v2/autoContract/doc/' + auto.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + auto.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isCDocQrLoading');
            },
            contractDoc: function (auto) {
                this.loading.isCDocLoading = true;
                this.downloadFile('/v2/autoContract/doc/' + auto.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + auto.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isCDocLoading');
            },
            contractPdf: function (auto) {
                this.loading.isCPdfLoading = true;
                this.downloadFile('/v2/autoContract/pdf/' + auto.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + auto.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfLoading');
            },
            contractQrCodePdf: function (auto) {
                this.loading.isCPdfQrLoading = true;
                this.downloadFile('/v2/autoContract/pdf/' + auto.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + auto.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfQrLoading');
            },
            sendReportToMIBAsset: function (auto) {
                this.processing = true;
                this.$http.get('/sendApiMibConfirmReport/pdf/' + auto.id + '/WITH_QR_CODE/Auto', {responseType: 'arraybuffer'})
                    .then(response => {
                        if (response && response.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('realEstate.report.titleQrCode'),
                                type: 'success'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            showReport: function () {
                this.$http.post('auto/show-report/' + this.auto.id + '/' + this.auto.displayReport)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showReportSuccess'),
                                type: 'success'
                            });
                            this.auto.appraisalStatusEnum = status;
                        } else if (res && res.data && res.data.status === 'FAIL') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                                type: 'success'
                            });
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.showReportError'),
                            type: 'error'
                        });
                    });
            },
            getEvaluationRespectiveType() {
                this.$http.get('/evaluationRespectiveType').then(response => {
                    this.evaluationRespectiveTypes = response.data;
                }, err => {
                    console.log(err)
                });
            },
            deleteAuto: function (auto) {
                this.processing = true;
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('auto.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('delete/appraisal/' + auto.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('auto.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.$router.push('/auto/list');
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('auto.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    } else {
                        this.processing = false;
                    }
                });
            },
            showAutoCalculation(autoId) {
                this.$eventBus.$emit('AutoEvaluationCalculation', autoId);
            },
            showCorrectionType(auto) {
                this.$eventBus.$emit('AutoCorrectionType', auto.id);
            },
            showComparative(autoId) {
                this.$eventBus.$emit('AutoComparative', autoId);
            },
            showComparativeMutable(autoId) {
                this.$eventBus.$emit('ComparativeMutable', autoId);
            },
            showDefectAct(autoId) {
                this.$eventBus.$emit('DefectAct', autoId);
            },
            rejectOrder() {
                this.$eventBus.$emit('RejectComment', this.auto.id, this.isLoses, "Auto");
            },
            showEsp(id, signer) {
                this.$eventBus.$emit('EspModal', id, signer);
            },

            openSignPageDirector: function (auto) {
                this.processing = true;
                this.$http.get('/esign/director/' + auto.id + '/Auto')
                    .then(response => {
                        if (response && response.status === 200) {
                            window.open(response.data.data);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: response.data.message,
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            openSignPageAppraiser: function (auto) {
                this.processing = true;
                this.$http.get('/esign/appraiser/' + auto.id + '/Auto')
                    .then(response => {
                        if (response && response.status === 200) {
                            window.open(response.data.data);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: response.data.message,
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            isRoleDirector() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role == "ROLE_DIRECTOR") {
                        return this.isDirector = true;
                    }

                }
            },
            isRoleAppraiser() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role == "ROLE_APPRAISER") {
                        return this.isAppraiser = true;
                    }
                }
            },
            sendingExpert2ToAgent() {
                this.processing = true;
                this.isPageLoadInit = true;
                this.$http.get('send/expert2/agent/' + this.auto.id).then(response => {
                    this.$swal({
                        title: this.$t('messages.common.success'),
                        text: response.data.message,
                        type: 'success'
                    });
                    this.processing = false;
                }).catch(err => {
                    console.log(err);
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('messages.common.error'),
                        type: 'warning'
                    });
                    this.processing = false;
                });
            },
            sendEvaluationObjectToIdentification: function (auto) {
              this.processing = true;
              this.$http.get('/auto/send-evaluation-object-identification/' + auto.id)
                  .then(response => {
                    if (response && response.status === 200) {
                      this.$router.push('/auto/edit/' + this.auto.id);
                    } else {
                      this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: response.data.message,
                        type: 'warning'
                      });
                    }
                    this.processing = false;
                  })
                  .catch(err => {
                    console.log(err);
                    this.$swal({
                      title: this.$t('messages.common.warning'),
                      text: this.$t('messages.common.error'),
                      type: 'warning'
                    });
                    this.processing = false;
                  })
            }
        },
        created() {
            this.init();
            this.getEvaluationRespectiveType();
            this.isRoleDirector();
            this.isRoleAppraiser();
        }
    }
</script>

<style scoped>

</style>
